export default __webpack_public_path__ + "static/media/25.07ba487b.svg";